<!-- UniInput: Universal Text Input Component -->

<template>
	<div class="uniinput-main">

		<div class="uniinput-content" v-if="compData.multiLine">
			<textarea 
				v-model="txtVal" 
				:maxlength="maxLen" 
				:style="inputStyle"
				ref="myInput"
				rows="2"
				cols="12"
			>
			</textarea>
		</div>
 
		<div class="uniinput-content" v-else>
			<input  
				v-model="txtVal" 
				:maxlength="maxLen" 
				:style="inputStyle"
				:type="inputType"
				ref="myInput"
			/>
		</div>


		<div class="status-box" :style="statusStyle">
			Input length: {{txtVal.length}} / {{maxLen}}
		</div>

		<div class="save-box wi8_font" @click="clickSave">
			<div class="label">
				OK
			</div>
			<div class="btn-box">
				<UniIcon 
					ico="check"
					fit="1"
					color="#090"
				/>
			</div>
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import * as Utils from "@/utils/utils"
import CfgApp from "@/assets/cfg/CfgApp";
import { mapState, mapGetters } from "vuex";
import { eventBus } from '@/main';
import Vue from "vue";

export default {
	data() {
		return {
			txtVal: "",
			inputStyles: {
				single:	"width: 280px;	height: 25px;",
				multi:	"width: 100%;  height: 120px;",
			},
			inputStyle: "",
			maxLen: 10,
			inputType: "",
		}
	},
	props: {
		compData: { type: Object, default: function () {return {}} },
	},
	watch: {
		"compData": {
			deep: true,
			immediate: true,
			handler: function(newVal, oldVal) {
				m("uninput: compdata changed to", newVal, typeof newVal);
				this.initInput();
			}
		},
	},
    computed: {
		statusStyle: function () {
			let style={};
			if (this.txtVal.length >= this.maxLen) {
				style={
					color: "red",
					fontWeight: "bold",
				}
			}
        	return style;
		},
	},
	methods: {
		goTest() {
			m("uninput: go test");
		},
		goClose() {
			m("uninput: go close");	
			eventBus.$emit("popoff");
		},
		clickSave() {
			m("uninput: click save", this.txtVal);
			// Check toggleRole hotWord
			if (this.txtVal == CfgApp.toggleRole.hotWord) {
				this.txtVal = "";
				this.$store.dispatch("app/toggleRole");
			
			// Fire update event
			} else {
				const payload = {
					colName: this.compData.colName,
					val: Utils.sanitizeUserData(this.txtVal),
				}
				eventBus.$emit('update-value', payload);
			}
			
			// Close this popup
			this.goClose();
			
		},
		initInput() {
			m("uninput: init input");
			this.txtVal = this.compData.defaultVal || "";
			let maxLenDefault = (this.compData.multiLine)? 500: 100;
			this.maxLen = this.compData.maxLen || maxLenDefault;
			this.inputType = this.compData.inputType || "text";
			this.inputStyle = (this.compData.multiLine)? this.inputStyles.multi: this.inputStyles.single;
		},
		handleKey(evt) {
			m("uninput: handle key: " + evt.key, this.txtVal);
			if (evt.key && evt.key.indexOf('Ent')===0 && !this.compData.multiLine) {
				this.clickSave();
			}
		},
	},
	created() {
		m("uninput: created");
		window.addEventListener("keydown", this.handleKey);
	},
	beforeDestroy() {
		m("uninput: bef destroy");
		window.removeEventListener("keydown", this.handleKey);
	},
	mounted() {
		m("uninput: mounted");
		Vue.nextTick().then( () => { this.$refs.myInput.focus(); });
	},
}
</script>

<style scoped>

.uniinput-main {
	height: 100%;
	overflow: hidden;
	padding: 10px;
	border: solid 0px #C30;
}

.uniinput-content {
	overflow: hidden;
	border: solid 0px #090;
}

textarea {
	resize: none;
}

.status-box {
	height: 30px;
	overflow: hidden;
	border: solid 0px #F60;
}

.save-box {
	width: 80px;
	height: 40px;
	overflow: hidden;
	cursor: pointer;
	background-color: #FFF;
	border-radius: 5px;
	border: solid 2px #369;
}

.label {
	display: inline-block;
	width: 40px;
	overflow: hidden;
	padding: 10px 0px 0px 5px;
	border: solid 0px #C30;
}

.btn-box {
	float:right;
	width: 36px;
	height: 36px;
	overflow: hidden;
	cursor: pointer;
	border: solid 0px #C30;
}

</style>
